import { tsValidateArray, tsValidateResult, tsValidateString, tsValidateValue } from '@nu-art/ts-common';
import { FHIRQueryResourceParamType_Dynamic, FHIRQueryResourceParamType_Mandatory, FHIRQueryResourceParamType_Optional } from './types.js';
const Validator_FHIRQueryResourceParamValue = {
    value: tsValidateString(),
    label: tsValidateString(),
};
const Validator_FHIRQueryResourceParam_Optional = {
    type: tsValidateValue([FHIRQueryResourceParamType_Optional]),
    param: tsValidateString(),
    values: tsValidateArray(Validator_FHIRQueryResourceParamValue),
};
const Validator_FHIRQueryResourceParam_Mandatory = {
    type: tsValidateValue([FHIRQueryResourceParamType_Mandatory]),
    param: tsValidateString(),
    values: tsValidateArray(Validator_FHIRQueryResourceParamValue),
};
const Validator_FHIRQueryResourceParam_Dynamic = {
    type: tsValidateValue([FHIRQueryResourceParamType_Dynamic]),
    param: tsValidateString(),
};
const Validator_FHIRQueryResourceParam = (instance) => {
    if (!instance.type)
        return { type: 'Missing mandatory field' };
    switch (instance.type) {
        case FHIRQueryResourceParamType_Optional:
            return tsValidateResult(instance, Validator_FHIRQueryResourceParam_Optional);
        case FHIRQueryResourceParamType_Mandatory:
            return tsValidateResult(instance, Validator_FHIRQueryResourceParam_Mandatory);
        case FHIRQueryResourceParamType_Dynamic:
            return tsValidateResult(instance, Validator_FHIRQueryResourceParam_Dynamic);
        default:
            // @ts-ignore
            return `Unknown param type ${instance.type}`;
    }
};
export const Validator_FHIRQueryResource = {
    resource: tsValidateString(),
    label: tsValidateString(),
    params: tsValidateArray(Validator_FHIRQueryResourceParam)
};
//# sourceMappingURL=validator.js.map